import { ClaimDetailsModal } from "components/ClaimDetailsModal/ClaimDetailsModal";
import { Button } from "primereact/button";
import { useGetClaimByIdQuery } from "store/queries/claims";

import { pverifyRequestUrl } from "./remitAccuracyWording";

/**
 * CLE-2818 — the links every check list on the Remit accuracy tab shares: the check in pVerify's portal,
 * and the remit value that opens its claim.
 */

/** The RequestID number only, linking to the check in pVerify's portal. No RequestID reads "—". */
export function PverifyRequestLink({
  requestId,
}: {
  requestId: string | null;
}) {
  if (!requestId) return <span>—</span>;
  return (
    <a
      href={pverifyRequestUrl(requestId)}
      target="_blank"
      rel="noopener noreferrer"
      className="white-space-nowrap"
    >
      {requestId}
    </a>
  );
}

/** The remit value as a link to its claim; with no value to show it reads "View claim". */
export function RemitClaimLink({
  claimId,
  text,
  onOpen,
}: {
  claimId: string | null | undefined;
  text: string;
  onOpen: (claimId: string) => void;
}) {
  const label = text && text !== "—" ? text : "View claim";
  if (!claimId) return <span>{text || "—"}</span>;
  return (
    <Button
      type="button"
      label={label}
      className="p-button-link p-button-sm p-0 text-left"
      data-testid="remitAccuracy.remitClaimLink"
      onClick={() => onOpen(claimId)}
    />
  );
}

export function RemitClaimModal({
  claimId,
  accountId,
  onHide,
}: {
  claimId: string;
  accountId: string;
  onHide: () => void;
}) {
  const { data } = useGetClaimByIdQuery({ claimId });
  if (!data) return null;
  return (
    <ClaimDetailsModal
      visible
      onHide={onHide}
      claim={data}
      accountId={accountId}
    />
  );
}
